export default __webpack_public_path__ + "static/media/kitchen4-afterB-1440w.09e1e856.webp";